<template>
    <a-modal
        :width="800"
        :visible="modalVisible"
        title="添加/编辑配置"
        @cancel="closeModal"
        @ok="handleSubmit"
        :maskClosable="false"
        :confirmLoading="that.loading.effects[addType] ||that.loading.effects[editType]"
    >
        <a-form @submit="handleSubmit" layout="inline" :form="form">
            <a-form-item label="配置名称">
                <a-input
                    style="width:300px"
                    v-decorator="[
                                'configname',
                                {
                                    initialValue: that.record.configname,
                                    rules: [{ required: true, message: '请输入配置名称' }]
                                }
                            ]"
                    placeholder="请输入配置名称"
                />
            </a-form-item>
            <div class="mb20"></div>
            <a-form-item label="配置动态项">
                <div id="configtable" style="width: 650px; overflow: auto;">
                    <a-table
                        style="width: 100%;"
                        :columns="columns"
                        :rowKey="record => record.id ? record.id : Math.random()"
                        :dataSource="list"
                        :pagination="false"
                    ></a-table>
                </div>
                <div class="mt10">
                    <a-button @click="e => addcolumn(e)">新增一列</a-button>
                </div>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
const storeNamespace = "rc_io";
import $ from 'jquery'
export default {
    data() {
        return {
            list: this.record.config ? JSON.parse(this.record.config) : [],
            that: this,
            form: this.$form.createForm(this),
            modalVisible: this.visible,
            addType: `${storeNamespace}/addconfig`,
            editType: `${storeNamespace}/editconfig`,
            columns: [
                {
                    title: "序号",
                    width: 60,
                    align: "center",
                    customRender: (text, record, index) => ++index
                },
                {
                    title: "key-配置参数",
                    dataIndex: "key",
                    customRender: (text, record, index) => (
                        <a-input
                            onChange={e =>
                                this.changeValue(e, record, index, "key")
                            }
                            defaultValue={text}
                        />
                    )
                },
                {
                    title: "value-参数值",
                    dataIndex: "value",
                    customRender: (text, record, index) => (
                        <a-input
                            onChange={e =>
                                this.changeValue(e, record, index, "value")
                            }
                            defaultValue={text}
                        />
                    )
                },
                {
                    title: "操作",
                    width: 60,
                    align: "center",
                    customRender: (text, record, index) => {
                        return (
                            <a onClick={() => this.removeItem(record, index)}>
                                删除
                            </a>
                        );
                    }
                }
            ]
        };
    },
    computed: {},
    methods: {
        changeValue(e, record, index, field) {

            this.list[index][field] = $.trim(e.target.value);
        },
        removeItem(record, index) {
            this.list.splice(index, 1);
        },
        addcolumn(e) {
            e.preventDefault();
            let obj = {
                id: new Date().getTime(),
                key: "",
                value: ""
            };
            this.list.push(obj);
            setTimeout(function() {
                $("#configtable")
                    .find("tr:last")
                    .find("input")
                    .eq(0)
                    .focus();
            }, 300);
        },
        showModal() {
            this.modalVisible = true;
        },
        closeModal() {
            this.modalVisible = false;
        },
        //过滤空数据
        filterdata(values = []) {
            if (values.length === 0) return [];
            return values.filter((item, index) => {
                item.key = $.trim(item.key);
                item.value = $.trim(item.value);
                if (item.key == "" && item.value != "") {
                    let msg = `第${index + 1}项的key不能为空`;
                    this.message.warn(msg);
                    $("#configtable tbody tr")
                        .eq(index)
                        .find("input")
                        .eq(0)
                        .focus();
                    throw new Error(msg);
                }
                if (item.value == "" && item.key != "") {
                    let msg = `第${index + 1}项的value不能为空`;
                    this.message.warn(msg);
                    $("#configtable tbody tr")
                        .eq(index)
                        .find("input")
                        .eq(1)
                        .focus();
                    throw new Error(msg);
                }
                return item.key !== "" && item.value !== "";
            });
        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (err) return;
                let newlist = this.filterdata(this.list);
                if (newlist.length === 0) {
                    let msg = "请添加配置之后再保存。";
                    this.message.warn(msg);
                    throw new Error(msg);
                }

                let params = {
                    id: this.record.id || undefined,
                    configname: values.configname,
                    config: JSON.stringify(newlist),
                    systemname: this.$route.query.systemname,
                    serverip: this.$route.query.serverip
                };
                this.$store
                    .dispatch({
                        type:
                            this.action == "edit"
                                ? this.editType
                                : this.addType,
                        params
                    })
                    .then(() => {
                        this.$router.push({
                            path: "config",
                            query: {
                                ...this.$route.query,
                                _t: new Date().getTime()
                            }
                        });
                    });
            });
        }
    },
    beforeMount(){
        // console.log(this, "this")
    },
    props: {
        record: {
            // type: Object,
            default: {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        action: {
            // type: Object,
            default: "add"
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
